import Collection from '../../utils/Collection';

import { FETCH_TIMESLOT_STATUSES_SUCCEEDED } from '../../actions/timeslot';

import {
  FETCH_TUTORS_SENT,
  FETCH_TUTORS_SUCCEEDED,
  FETCH_TUTORS_FAILED,
  FETCH_TUTOR_SENT,
  FETCH_TUTOR_SUCCEEDED,
  FETCH_TUTOR_FAILED,
} from '../../actions/tutor';

const initialState = {
  loading: false,
  tutors: [],
  count: 0,
};

export default function tutorReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_TIMESLOT_STATUSES_SUCCEEDED:
      return {
        ...state,
        loading: false,
        count: payload.total,
        tutors: Collection.reset(state.tutors, payload.tutors),
      };
    case FETCH_TUTORS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        tutors: Collection.reset(state.tutors, payload.tutors),
      };
    case FETCH_TUTOR_SUCCEEDED:
      return {
        ...state,
        loading: false,
        tutors: Collection.update(state.tutors, payload.user.id, payload.user),
      };
    case FETCH_TUTORS_FAILED:
    case FETCH_TUTOR_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_TUTORS_SENT:
    case FETCH_TUTOR_SENT:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
